// eslint-disable-next-line no-shadow
export var SORT_STATUS = /*#__PURE__*/function (SORT_STATUS) {
  SORT_STATUS["DESC"] = "desc";
  SORT_STATUS["ASC"] = "asc";
  return SORT_STATUS;
}({});